import { render } from "./organisation-listing-overview.vue?vue&type=template&id=12410002&ts=true"
import script from "./organisation-listing-overview.ts?vue&type=script&lang=ts&external"
export * from "./organisation-listing-overview.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__